import { trpc } from '../../lib/trpc';
import { VenueCard } from '../VenueCard';

export const FavoriteVenuesTab = () => {
  const { data, isLoading, error } = trpc.user.getFavorites.useQuery();

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-700" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-error">Failed to load favorites. Please try again.</p>
      </div>
    );
  }

  const venues = data?.venues ?? [];

  if (venues.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">No Favorite Venues</h3>
        <p className="text-sm text-gray-500">
          Tap the heart icon on venues to add them to your favorites.
        </p>
      </div>
    );
  }

  return (
    <section>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Favorite Venues ({venues.length})
      </h3>
      <ul className="divide-y divide-gray-200">
        {venues.map((venue) => (
          <VenueCard
            key={venue._id}
            venue={venue}
            logoMedia={venue.logoImage ?? null}
          />
        ))}
      </ul>
    </section>
  );
};
